module.exports = __webpack_public_path__ + "img/Good RSSI Icon 2.463ef4e0.png";